import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { PlandayService } from '@fi-app/external-platform-integration/planday/planday.service';
import { ProgressType } from '@fi-shared/fi-signal-r/fi-signal-enums';
import { FiSpinnerService } from '@fi-shared/fi-spinner/fi-spinner.service';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'planday-import-units',
    templateUrl: './planday-import-units.component.html',
    styleUrls: ['./planday-import-units.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'planday-import-units' },
    standalone: false,
})
export class PlandayImportUnitsComponent {
    constructor(
        private plandayService: PlandayService,
        private fiSpinnerService: FiSpinnerService,
        private appTextService: AppTextService,
    ) {}

    onTestImportUnitsClick() {
        const isTestMode = true;
        const promise = this.plandayService.importPlandayUnits(isTestMode);
        this.showProgress(promise, isTestMode);
    }

    onImportUnitsClick() {
        const isTestMode = false;
        const promise = this.plandayService.importPlandayUnits(isTestMode);
        this.showProgress(promise, isTestMode);
    }

    private showProgress(promise: Promise<any>, isTestMode: boolean) {
        let headerTextId: string;
        if (isTestMode) {
            headerTextId = 'pk.testing_import';
        } else {
            headerTextId = 'import.importing_units';
        }
        this.fiSpinnerService.trackPromise(promise, {
            headerText: this.appTextService.get(headerTextId),
            signalRProgressType: ProgressType.PlandayImportUnits,
        });
    }
}
